import { render } from "./DynamicTable2 copy.vue?vue&type=template&id=cdee9db6&scoped=true"
import script from "./DynamicTable2 copy.vue?vue&type=script&lang=js"
export * from "./DynamicTable2 copy.vue?vue&type=script&lang=js"

import "./DynamicTable2 copy.vue?vue&type=style&index=0&id=cdee9db6&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdee9db6"]])

export default __exports__